export const getFileExtensionFromName = (fileName) => {
  if (typeof fileName !== 'string') {
    throw new Error('File name must be of type string');
  }

  const fineNameSplitted = fileName.split('.');
  const isThereAnExtension = fineNameSplitted.length > 1;

  if (!isThereAnExtension) {
    throw new Error('File name has no extension');
  }

  const filExtension = fineNameSplitted[fineNameSplitted.length - 1];
  return filExtension;
};
